import type { DefaultTheme } from 'styled-components';
import type { SpeakerBioGridItemStyleStrategy } from '../components/SpeakerBioStyles';

export class StyleVariableFactories {
  private readonly themeColors: DefaultTheme['color'];

  private constructor(themeColors: DefaultTheme['color']) {
    this.themeColors = themeColors;
  }

  public static create(themeColors: DefaultTheme['color']): StyleVariableFactories {
    return new StyleVariableFactories(themeColors);
  }

  public speakerAvatarBadgeBackgroundColor(
    styleStrategy?: SpeakerBioGridItemStyleStrategy,
  ): string {
    switch (styleStrategy) {
      case 'event-room':
        return 'var(--event-room-primary-color)';
      case 'registration-page':
        return 'var(--event-registration-primary-color)';
      case undefined:
      default:
        return this.themeColors.brandBlue500;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  public speakerAvatarBadgeTextColor(styleStrategy?: SpeakerBioGridItemStyleStrategy): string {
    switch (styleStrategy) {
      case 'event-room':
        return 'var(--event-room-primary-text-color)';
      case 'registration-page':
        return 'var(--event-registration-primary-text-color)';
      case undefined:
      default:
        return 'white';
    }
  }

  public speakerAvatarBackgroundColor(styleStrategy?: SpeakerBioGridItemStyleStrategy): string {
    switch (styleStrategy) {
      case 'event-room':
        return 'var(--event-room-heavy-accented-background-color)';
      case 'registration-page':
        return 'var(--event-registration-heavy-accented-background-color)';
      case undefined:
      default:
        return this.themeColors.grey300;
    }
  }

  public speakerAvatarIconColor(styleStrategy?: SpeakerBioGridItemStyleStrategy): string {
    switch (styleStrategy) {
      case 'event-room':
        return 'var(--event-room-heavy-accented-text-color)';
      case 'registration-page':
        return 'var(--event-registration-heavy-accented-text-color)';
      case undefined:
      default:
        return this.themeColors.grey800;
    }
  }

  public socialMediaSvgFillColor(styleStrategy?: SpeakerBioGridItemStyleStrategy): string {
    switch (styleStrategy) {
      case 'event-room':
        return 'var(--event-room-speaker-social-fill-color)';
      case 'registration-page':
        return 'var(--event-registration-speaker-social-fill-color)';
      case undefined:
      default:
        return this.themeColors.grey1000;
    }
  }

  public socialMediaSvgStrokeColor(styleStrategy?: SpeakerBioGridItemStyleStrategy): string {
    switch (styleStrategy) {
      case 'event-room':
        return 'var(--event-room-speaker-social-stroke-color)';
      case 'registration-page':
        return 'var(--event-registration-speaker-social-stroke-color)';
      case undefined:
      default:
        return this.themeColors.grey500;
    }
  }
}
